// extracted by mini-css-extract-plugin
export default {"root":"style_root__IDm-4","players":"style_players__G8irh"};